import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-brand-gray-dark rounded-2xl p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-start justify-between mb-12">
            <div className="flex items-center space-x-4">
              <img src="/icon.png" alt="Universal Pays Logo" className="w-12 h-12" />
              <h1 className="text-4xl font-bold gradient-text">Terms of Service</h1>
            </div>
            <Link 
              to="/"
              className="text-gray-400 hover:text-brand-blue transition-colors duration-300 text-sm"
            >
              ← Back to Home
            </Link>
          </div>

          <div className="space-y-8">
            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-300">
                Welcome to Universal Pays! These Terms of Service ("Terms") govern your use of our website and services. By accessing or using our website, you agree to be bound by these Terms.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">2. Services</h2>
              <p className="text-gray-300">
                We provide various payment processing services including but not limited to cryptocurrency transactions, wire transfers, and eVoucher solutions. We reserve the right to modify or discontinue services at any time.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">3. User Obligations</h2>
              <ul className="list-disc list-inside text-gray-300 space-y-2">
                <li>Provide accurate and complete information when registering</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not use our services for illegal or unauthorized activities</li>
              </ul>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">4. Intellectual Property</h2>
              <p className="text-gray-300">
                All content, trademarks, and intellectual property on our website are owned by Universal Pays or its licensors. You may not use any content without prior written permission.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">5. Privacy</h2>
              <p className="text-gray-300">
                We collect and process personal information in accordance with our Privacy Policy. By using our services, you consent to the collection and processing of your data as described in our Privacy Policy.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">6. Limitation of Liability</h2>
              <p className="text-gray-300">
                To the maximum extent permitted by law, we disclaim all warranties, express or implied, including but not limited to warranties of merchantability and fitness for a particular purpose.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">7. Governing Law</h2>
              <p className="text-gray-300">
                These Terms shall be governed by and construed in accordance with the laws of the jurisdiction where Universal Pays is registered.
              </p>
            </div>

            <div className="border-b border-brand-gray pb-6">
              <h2 className="text-2xl font-bold mb-4">8. Changes to Terms</h2>
              <p className="text-gray-300">
                We reserve the right to modify these Terms at any time. Continued use of our services after any modifications constitutes your acceptance of the new Terms.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold mb-4">9. Contact Information</h2>
              <p className="text-gray-300">
                If you have any questions about these Terms, please contact us at:
                <br />
                Email: <a href="mailto:support@universalpays.com" className="text-brand-blue hover:underline">support@universalpays.com</a>
                <br />
                Phone: <a href="tel:+13658290725" className="text-brand-blue hover:underline">+13658290725</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
